module.exports = __webpack_public_path__ + "img/ndalegal-folder.6ed3181f.jpg";